import { CheckCircle2 } from 'lucide-react';

import { SoftCard } from '@/components/ui/soft-card';

import { HideButton } from './HideButton';
import { MarkAsDoneButton } from './MarkAsDoneButton';

/**
 * A self-attested "win" the retailer marks done themselves (email button, Apple
 * Business Connect link, shop-window QR). Controlled + server-persisted via
 * useLocalPotentialActions (NEA-5765); ported from the fresh-dashboard design.
 */
export function ClaimableWinCard({ icon: Icon, title, body, uplift, activated, onToggle, comingSoon, onHide, onUnhide }) {
	return (
		<SoftCard className="relative overflow-hidden bg-white !p-5 md:!p-6">
			{activated ? <span className="absolute bottom-0 left-0 top-0 w-1 bg-success" aria-hidden /> : null}
			<div className="flex items-start gap-4">
				<div
					className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${activated ? 'bg-success text-white' : 'bg-success-soft text-success-soft-foreground'}`}
				>
					<Icon className="h-5 w-5" />
				</div>
				<div className="min-w-0 flex-1">
					<div className="flex flex-wrap items-center gap-2">
						<h3 className="text-[15px] font-bold text-foreground md:text-base">{title}</h3>
						{comingSoon ? (
							<span className="inline-flex items-center gap-1 rounded-full border border-border bg-accent/40 px-2.5 py-1 text-xs font-semibold text-muted-foreground">
								Coming soon
							</span>
						) : activated ? (
							<span className="inline-flex items-center gap-1.5 rounded-full bg-success px-2.5 py-1 text-xs font-extrabold text-white">
								<CheckCircle2 className="h-3.5 w-3.5" /> Live · +{uplift}%
							</span>
						) : (
							<span className="inline-flex items-center gap-1 rounded-full border border-success/40 bg-white px-2.5 py-1 text-xs font-semibold text-success">
								<span aria-hidden className="h-2 w-2 rounded-full bg-success" /> +{uplift}%
							</span>
						)}
					</div>
					<p className="mt-1 text-sm text-muted-foreground">{body}</p>
				</div>
				{!activated && onHide ? <HideButton onClick={onHide} /> : null}
				{onUnhide ? <HideButton onClick={onUnhide} mode="unhide" /> : null}
				{!comingSoon ? <MarkAsDoneButton activated={activated} onToggle={onToggle} /> : null}
			</div>
		</SoftCard>
	);
}
